
import React from "react";

export const EmptyOfferings: React.FC = () => {
  return (
    <div className="bg-[#181D24] rounded-xl p-5 text-center border border-[#222A35]">
      <p className="text-gray-300">Você não tem mentorias disponíveis para organizar.</p>
    </div>
  );
};
